import store from "store";
import { create } from "zustand";

const useSessionStore = store.createStore([
  require("store/storages/sessionStorage"),
]);

const useSocketStore = create((set) => ({
  client: null,
  setClient: (socketClient) => set(() => ({ client: socketClient })),
}));

const useMsgStore = create(() => ({
  manualStoppedMsgIds: [],
}));

export { useSessionStore, useSocketStore, useMsgStore };
